import { IconAccordionCaretDown } from '@lmig/lmds-react-icons';
import { GetSiteStates, IStateObject } from 'Foundation/Common/StateHelper';
import { useUserData } from 'Foundation/User/UserContext';
import { useEffect, useState } from 'react';
import './GlobalStateDropdown.scss';

export function GlobalStateDropdown() {
  const { userData, updateSelectedState } = useUserData();
  const [states, setStates] = useState<IStateObject[]>([]);

  useEffect(() => {
    if (userData?.channel) setStates(GetSiteStates(userData.channel));
  }, [userData?.channel]);

  const onStateSelected = async (newState: string) => {
    try {
      const res = await updateSelectedState(newState);
      if (res !== '') {
        window.location.reload();
      }
    } catch {
      console.error("Error saving user's global state");
    }
  };

  const handleChangeState = (event: any, state: string) => {
    if (event.key === 'Enter') {
      onStateSelected(state);
    }
  };

  return (
    <>
      {userData && userData.state === '' && <div className="global-state-selector-overlay"></div>}
      {userData && (
        <div className={'global-state-dropdown ' + userData.channel.toLowerCase()}>
          <div
            className={'state-dropdown-toggle' + (userData.state === '' ? ' open' : '')}
            data-toggle="dropdown"
            data-display="static"
            tabIndex={0}
            aria-label="selected state"
          >
            {userData.state !== ''
              ? userData.state.toUpperCase()
              : userData.isPL && userData.isPL()
              ? 'REQUIRED'
              : 'Please select a state to begin'}
            <IconAccordionCaretDown title="" />
          <div className="state-specific-dropdown-menu dropdown-menu">
            <svg height="7" width="14" className="icon-up">
              <polygon points="0,7 7,0 14,7" />
            </svg>
            <div className="dropdown-menu-content">
              {userData.isPL && userData.isPL() && (
                <div className="dropdown-menu-leading-text">
                  <h3>Please select a state to begin</h3>
                </div>
              )}
              <div className="dropdown-menu-leading-text">
                Select from the list below to write and service business in that state. You can change your selection at
                any time.
              </div>
              <div className="dropdown-states" aria-label="state list">
                {states.map((state) => (
                  <div
                    className="state-specific-selector-state-text dropdown-item"
                    aria-label={state.Name}
                    onClick={() => onStateSelected(state.Abbreviation)}
                    onKeyPress={(e) => handleChangeState(e, state.Abbreviation)}
                    tabIndex={0}
                  >
                    {state.Abbreviation} - {state.Name}
                  </div>
                ))}
              </div>
            </div>
          </div>
          </div>
        </div>
      )}
    </>
  );
}
